export const storyListItemsSelector = (state) => state.storyList.storyList;
export const storyListUsersSelector = (state) => state.storyList.users;
export const storyListLoadingSelector = (state) => state.storyList.loading;
export const storyListCurrentStorySelector = (state) =>
  state.storyList.currentStory;
export const storyListEditStatusSelector = (state) => state.storyList.wasEdit;
export const storyListLanguageSelector = (state) =>
  state.storyList.currentLanguage;
